<template>
  <div class="foots">
    <div class="foot">
      <div class="foot1 footer-col">
        <div>
          <p>Games</p>
          <router-link to="/games/lucky-ball-5">Lucky 5 Ball</router-link>
          <router-link to="/games/lucky-ball-8">Lucky 8 Ball</router-link>
          <router-link to="/games/lucky-ball-10">Lucky 10 Ball</router-link>
          <router-link to="/games/lucky-ball-20">Lucky 20 Ball</router-link>
        </div>
      </div>
      <div class="foot2 footer-col">
        <p>Results</p>
        <router-link to="/results/lucky-ball-5">Lucky 5 Ball</router-link>
        <router-link to="/results/lucky-ball-8">Lucky 8 Ball</router-link>
        <router-link to="/results/lucky-ball-10">Lucky 10 Ball</router-link>
        <router-link to="/results/lucky-ball-20">Lucky 20 Ball</router-link>
      </div>
      <div class="foot3 footer-col">
        <p>About</p>
        <router-link to="/about/about-lucky-lottery">About Lucky Lottery</router-link>
        <router-link to="/about/responsible-play-program">Responsible Play Program</router-link>
        <div class="foot3_right">
          <router-link to="/about/is-gambling-affecting-your-health">Is Gambling affecting<br>your health</router-link>
          <router-link to="/about/problem-gambling-help">Problem Gambling Help</router-link>
          <router-link to="/about/player-security">Player Security</router-link>
        </div>
        <router-link to="/about/giving-back">Giving Back</router-link>
        <router-link to="/about/news">News</router-link>
      </div>
      <div class="foot4 footer-col">
        <p>Help</p>
        <router-link to="/help/how-to-play">How to play</router-link>
        <router-link to="/help/how-to-claim-prizes">How to claim prizes</router-link>
      </div>
      <div class="foot5 footer-col">
        <p>You know the score.<br>
        Stay in control.<br>
        Gamble responsibly.</p>
        <router-link to="/about/responsible-play-program" class="responsible-play">
          RESPONSIBLE<br>PLAY >
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.foots {
  width: 100%;
  background-color: #f5f5f5;
  padding: 50px 0;
  margin-top: 60px;
  border-top: 1px solid #eee;
}

.foot {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 30px;
  padding: 0 20px;
  box-sizing: border-box;
}

.foot p {
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  font-size: 16px;
}

.foot a {
  display: block;
  color: #666;
  text-decoration: none;
  line-height: 2;
  font-size: 14px;
}

.foot a:hover {
  color: #e03997;
}

.foot3_right {
  margin: 15px 0;
  padding-left: 15px;
  border-left: 2px solid #ddd;
}

.foot5 p {
  font-style: italic;
  line-height: 1.5;
  margin-bottom: 20px;
}

.foot5 .responsible-play {
  display: inline-block;
  margin-top: 10px;
}

/* 响应式布局 */
@media (max-width: 992px) {
  .foot {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .foot5 {
    grid-column: span 3;
    text-align: center;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #ddd;
  }
}

@media (max-width: 768px) {
  .foot {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .foot5 {
    grid-column: span 2;
  }
  
  .foots {
    padding: 30px 0;
  }
}

@media (max-width: 576px) {
  .foot {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .footer-col {
    padding-bottom: 15px;
    margin-bottom: 15px;
    border-bottom: 1px solid #ddd;
  }
  
  .footer-col:last-child {
    border-bottom: none;
  }
  
  .foot5 {
    grid-column: span 1;
    margin-top: 0;
    padding-top: 0;
    border-top: none;
  }
  
  .foots {
    padding: 20px 0;
    margin-top: 40px;
  }
  
  .foot p {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Footer.vue